import { lazy } from 'react'
import WithPermission from 'Components/SharedComponents/WithPermission/WithPermission'

const CoachingPage = lazy(() => import('./CoachingContainer'))

export default {
  path: '/coaching',
  exact: false,
  Component: WithPermission(CoachingPage, ['page:coaching'], true),
  access: 'USER',
  routes: [
    {
      path: `/coaching`,
      exact: false,
      Component: WithPermission(CoachingPage, ['page:coaching'], true),
      routes: [
        {
          path: `/coaching/1-1-sessions`,
          exact: true,
          Component: WithPermission(
            CoachingPage,
            ['page:coaching:1_1_sessions'],
            true
          ),
        },
        {
          path: `/coaching/group-sessions`,
          exact: true,
          Component: WithPermission(
            CoachingPage,
            ['page:coaching:group_sessions'],
            true
          ),
        },
      ],
      access: 'USER',
    },
  ],
}
